import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-ca',
    // have a common namespace used around the full app
    ns: ['common'],
    defaultNS: 'common',
    debug: process.env.NODE_ENV !== 'production',
    interpolation: {
      escapeValue: false // not needed for react!!
    },
    backend: {
      loadPath: 'static/locales/{{lng}}/{{ns}}.json',

      // path to post missing resources
      addPath: 'locales/add/{{lng}}/{{ns}}'
    },
    react: {
      wait: true,
      useSuspense: false // TODO breaks production build, need to debug further (+ add suspense to root)
    }
  });
export default i18n;
